export enum PartsTypeEnum {
  Original = 'Oryginalnych',
}
